import React from 'react';
import { Paper, Typography, Box } from '@mui/material';
import {
    ResponsiveContainer,
    AreaChart,
    Area,
    XAxis,
    YAxis,
    Tooltip,
    CartesianGrid,
} from 'recharts';
import InsightsIcon from '@mui/icons-material/Insights';
import { DASHBOARD_COLORS } from './dashboardTheme';

const formatDay = (iso) => {
    try {
        const d = new Date(iso);
        return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
    } catch {
        return iso;
    }
};

export default function ActivityChart({ data }) {
    const hasData = Array.isArray(data) && data.length > 0 && data.some((d) => d.words > 0);

    return (
        <Paper
            sx={{
                p: 3,
                borderRadius: '16px',
                boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.06)',
                height: '100%',
                minHeight: 320,
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <Typography variant="h6" sx={{ mb: 2 }}>
                Translation activity (last 30 days)
            </Typography>
            {hasData ? (
                <Box sx={{ flex: 1, width: '100%', minHeight: 240 }}>
                    <ResponsiveContainer width="100%" height="100%">
                        <AreaChart data={data} margin={{ top: 10, right: 16, bottom: 0, left: 0 }}>
                            <defs>
                                <linearGradient id="activityFill" x1="0" y1="0" x2="0" y2="1">
                                    <stop offset="0%" stopColor={DASHBOARD_COLORS.chartFill} stopOpacity={0.4} />
                                    <stop offset="100%" stopColor={DASHBOARD_COLORS.chartFill} stopOpacity={0.02} />
                                </linearGradient>
                            </defs>
                            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#eee" />
                            <XAxis dataKey="date" tickFormatter={formatDay} tick={{ fontSize: 12 }} />
                            <YAxis tick={{ fontSize: 12 }} width={48} />
                            <Tooltip
                                labelFormatter={formatDay}
                                formatter={(value) => [`${value.toLocaleString()} words`, 'Translated']}
                            />
                            <Area
                                type="monotone"
                                dataKey="words"
                                stroke={DASHBOARD_COLORS.chartFill}
                                strokeWidth={2}
                                fill="url(#activityFill)"
                            />
                        </AreaChart>
                    </ResponsiveContainer>
                </Box>
            ) : (
                <Box
                    sx={{
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'text.secondary',
                        gap: 1,
                    }}
                >
                    <InsightsIcon sx={{ fontSize: 48, opacity: 0.4 }} />
                    <Typography variant="body2">No activity yet — start a project to see your trend.</Typography>
                </Box>
            )}
        </Paper>
    );
}
